import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Typography } from '@mui/material'
import { IWholesalerCatalog } from '@cbgms/api'
import { countryCodeToEmojiFlag } from '@carsys/form/src/CountriesDropdownBase'

export const VehicleSourceConfig: React.FC<{ cat: IWholesalerCatalog }> = ({ cat }) => {
  const { t } = useTranslation()

  return (
    <>
      <Typography variant='h4' mb={1}>
        {t('wholesaler-catalog.config-vehicle-sources')}
      </Typography>
      {cat.VehiclePrimaryVehicleSource && (
        <>
          <Box display='flex' alignContent='center'>
            {t('wholesaler-catalog.VehiclePrimaryVehicleSource')}: {cat.VehiclePrimaryVehicleSource}
          </Box>
          <VehicleSources cat={cat} />
        </>
      )}
    </>
  )
}

const VehicleSources: React.FC<{ cat: IWholesalerCatalog }> = ({ cat }) => {
  const { t } = useTranslation()
  const sources = cat.VehicleSources || []
  return (
    <Box>
      <Typography variant='h6'>{t('wholesaler-catalog.vehicle-sources-config')}</Typography>
      <Box>
        {sources.length === 0 && <Box sx={{ fontStyle: 'italic' }}>{t('wholesaler-catalog.vehicle-sources-default')}</Box>}
        {sources.map(s => (
          <Box key={`${s.Country}_${s.Source}_${s.Target}`}>
            <Box sx={{ display: 'inline-flex', gap: 1 }}>
              <Box minWidth={75}>
                <span className='emoji-flag'>{countryCodeToEmojiFlag(s.Country) || '\u00A0'}</span> {s.Country}
              </Box>
              <Box minWidth={150}>{s.Target}</Box>
              <Box>{s.Source}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}
